import { FiltersPresetsModel } from '@c/shared/filter-presets-menu/filters-presets.model';
import { ConsensusRatingFilterModel } from '@m1/wheel/wheel-scanner-filter/wheel-scanner-filter.model';
import { Flags } from '@mod/symbol-smiley/symbol-smiley.model';
import {
  AnalystConsensusRating,
  DividendsCount,
  EarningBeforeExpOptions,
  IWheelFilter,
  MinStrikeToLowestClose,
  SectorsFilter,
} from '@t/wheel/wheel.types';

export const consensusRatingOptionsForFilter: Array<ConsensusRatingFilterModel> = [
  { id: 1, title: 'Strong Buy', value: AnalystConsensusRating.StrongBuy },
  { id: 2, title: 'Buy', value: AnalystConsensusRating.Buy },
  { id: 3, title: 'Hold', value: AnalystConsensusRating.Hold },
  { id: 4, title: 'Sell', value: AnalystConsensusRating.Sell },
  { id: 5, title: 'Strong Sell', value: AnalystConsensusRating.StrongSell },
];

export const defaultPredefinedWheelPresets: Array<FiltersPresetsModel<IWheelFilter>> = [
  {
    id: 'default-wheel-preset-1',
    title: 'Default',
    settings: {
      flags: [Flags.No, Flags.Maybe, Flags.Yes, Flags.Never, Flags.None],
      minStrike: MinStrikeToLowestClose.AllStrikes,
      dividends: DividendsCount.AtLeastOne,
      marketCapFrom: { filterValue: '5000000000', visibleValue: '5B' },
      marketCapTo: { filterValue: '', visibleValue: '' },
      peRatioFrom: '',
      peRatioTo: '50.00',
      changeInPercentFrom: '',
      changeInPercentTo: '-1',
      sectors: SectorsFilter.All,
      expiration: 'All',
      strikeFrom: '15',
      strikeTo: '',
      roiFrom: '30',
      roiTo: '',
      premiumFrom: '0.1',
      premiumTo: '',
      dropInPercentFrom: '',
      dropInPercentTo: '',
      earningBeforeExp: EarningBeforeExpOptions.NotBeforeExp,
      consensusRatings: [],
      priceToAvgTargetFrom: '',
      priceToAvgTargetTo: '',
    },
  },
];
